<template>
  <div class="admin-brackets-container">
    <div class="header">
      Brackets
    </div>
    <Bracket
      v-for="bracket in brackets"
      :bracket="bracket"
      :key="bracket.id" />
    <div class="card">
      <div class="form-title">
        Crear nuevo
      </div>
      <div class="form">
        <div class="label">Inversión (centavos):</div>
        <BaseInput class="numbers-input" v-model="data.ticketValue" />
        <div class="label">Disponibles:</div>
        <BaseInput class="numbers-input" v-model="data.availableTickets" />
        <div class="label">Reservados:</div>
        <BaseInput class="numbers-input" v-model="data.backers" />
        <div class="label">Descripción:</div>
        <BaseInput v-model="data.description" />
        <div class="button" @click="addNewBracket">
          Guardar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput.vue';
import Bracket from '@/components/admin/Bracket.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('admin');

export default {
  data() {
    return {
      data: {
        ticketValue: 0,
        description: '',
        availableTickets: 0,
        backers: 0,
      },
    };
  },
  components: {
    BaseInput,
    Bracket,
  },
  methods: {
    async addNewBracket() {
      await this.createBracket({
        projectId: parseInt(this.$route.params.id, 10),
        data: this.data,
      });
      this.data = {
        ticketValue: 0,
        description: '',
        availableTickets: 0,
        backers: 0,
      };
    },
    ...mapActions([
      'getBrackets',
      'createBracket',
    ]),
  },
  computed: {
    ...mapState([
      'brackets',
    ]),
  },
  async mounted() {
    const projectId = parseInt(this.$route.params.id, 10);

    await this.getBrackets(projectId);
  },
};
</script>

<style lang="scss" scoped>
.admin-brackets-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: flex-start;
}
.header {
  font-size: 28px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.card {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  margin-top: 24px;
  width: 46%;
  display: flex;
  flex-wrap: wrap;
}
.form {
  width: 100%;
}
.form-title {
  font-weight: bold;
  font-size: 28px;
}
.label {
  margin-top: 18px;
  margin-bottom: 12px;
}
.numbers-input {
  width: 65%;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 20px;
  display: flex;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
